import { render } from "./AppHeader.vue?vue&type=template&id=6c372e6c"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=6c372e6c&lang=scss"
script.render = render

export default script